import PrivateAPIResource from "../../services/PrivateAPIResource";
import * as types from '../actionTypes';

function loadPortalsSuccess(portals) {
    return {type: types.LOAD_PORTALS_SUCCESS, portals};
}

export function loadPortals() {
    return function (dispatch) {
        return PrivateAPIResource.all('portals')
            .then((portals) => {
                dispatch(loadPortalsSuccess(portals));
            })
            .catch(err => {
                throw  err;
            });
    }
}





// WEBPACK FOOTER //
// ./web/src/actions/portal-contact/portalActions.js